import { addToCartEvent } from './utils/addToCart';

export function addToCartProductPageEvent() {
  const buttonList = document.querySelectorAll<HTMLButtonElement>(
    '[data-button-add-to-cart]',
  );

  buttonList.forEach((button) => {
    const id = button.dataset.ga4ProductId!;
    const itemName = button.dataset.ga4ProductName!;
    const price = Number(button.dataset.ga4ProductPrice)!;
    button.addEventListener('click', () => {
      const quantity =
        Number(
          document.querySelector<HTMLInputElement>(
            'input[name="quantity"]:checked',
          )?.value,
        ) ?? 1;

      const addedItem: Item = {
        item_id: id,
        item_name: itemName,
        price: price,
        quantity: quantity,
      };

      addToCartEvent(addedItem);
    });
  });
}
